module.exports = __webpack_public_path__ + "static/media/thumb_doubletreemakkah.e05fd3ab.jpg";